<div class="avatar-uploader-wrapper">
  <app-image-processing
    [imageUploadUrl]="avatarUploadUrl"
    [thumbnailPhotoUrl]="thumbnailPhotoUrl"
    [localAvatar]="localAvatar">
  </app-image-processing>
</div>
